<template>
  <div>
    <page-header
      :breadcrumRoutes="[
        {
          breadcrumbName: 'Cobranza y facturación',
          path: '/cobranza-facturacion'
        }
      ]"
      title="Formulario de inicio de cobranza"
    >
      <template #tags>
        <a-tag color="purple">
          {{
            getMonthNameByValue(
              dataFetchInfo?.period?.split('-')[1]
            )?.toUpperCase()
          }}
        </a-tag>
        <a-tag color="processing">ID: {{ form_id }}</a-tag>
      </template>

      <template #buttons>
        <a-row :gutter="10">
          <a-col>
            <a-button
              :loading="validateProcessing || loadingHumanSend"
              @click="cancelation_modal_visible = true"
              v-if="
                (form_current_state.state != 'CANCELLED' &&
                  form_current_state.state != 'LOADED') ||
                (form_current_state.state == 'LOADED' &&
                  validateStateCollectionHumanSend)
              "
            >
              Cancelar
            </a-button>
          </a-col>
          <a-col>
            <a-button
              :loading="validateProcessing"
              v-if="form_current_state.state == 'LOADED' && showValidateButton"
              @click="openModalValid"
              type="primary"
            >
              {{ !validateProcessing ? 'Validar' : 'Procesando...' }}
            </a-button>
          </a-col>
          <a-col>
            <a-button
              :loading="loadingHumanSend"
              v-if="
                form_current_state.state == 'LOADED' &&
                showSendHR &&
                validateStateCollectionHumanSend
              "
              type="primary"
              @click="OpenModalRRHH"
            >
              {{ !loadingHumanSend ? 'Enviar a RRHH' : 'Enviando...' }}
            </a-button>
          </a-col>

          <a-col>
            <a-button
              :loading="loadingApprovalCollectionGroup"
              v-if="
                form_current_state.state == 'LOADED' &&
                showApproveCollectionGroup &&
                userRole != 'rrhh'
              "
              type="primary"
              @click="openModalCollectionGroupApproval"
            >
              {{
                !loadingApprovalCollectionGroup
                  ? 'Aprobar cobranzas'
                  : 'Aprobando...'
              }}
            </a-button>
          </a-col>

          <a-col>
            <a-button
              :loading="loadingApprovalCollectionGroup"
              v-if="
                form_current_state.state == 'LOADED' &&
                approvedAndAvailableToPay &&
                userRole != 'rrhh'
              "
              type="primary"
              @click="openModalPayment"
            >
              {{
                !loadingApprovalCollectionGroup
                  ? 'Pagar facturas'
                  : 'Pagando...'
              }}
            </a-button>
          </a-col>
        </a-row>
      </template>
    </page-header>

    <stepper-cobranza :stepper-data="stepper_props" />

    <collection-list
      class="mt-3"
      v-if="form_current_state.state === 'LOADED'"
      :collection-form-id="form_id"
    />

    <a-card>
      <a-typography-title :level="3">Datos formulario</a-typography-title>

      <a-row class="mt-3" :gutter="16">
        <a-col :span="12">
          <data-info :data="ticket_data" />
        </a-col>
        <a-col :span="12">
          <comments
            title="Comentarios formulario"
            :data="comments"
            @commentCreation="getNewCommment"
            :idToTicket="$route.params.id"
          />
        </a-col>
      </a-row>
    </a-card>

    <payroll-procesing
      v-if="form_current_state.state === 'CREATED'"
      :collection-form-id="form_id"
      class="mt-3"
    />

    <detail-collection-billing
      v-if="
        form_current_state.state === 'PROCCESING' ||
        form_current_state.state === 'LOADED'
      "
      :current-collection-form-state="form_current_state.state"
      :validateApproved="validateApproved"
      :collection-start-form-state="form_current_state.state"
    />

    <collection-cancel-modal
      v-model="cancelation_modal_visible"
      :collection-form-id="form_id"
    />

    <collection-valid-modal
      :dataInfo="dataFetchInfo"
      v-model="modalValid"
      :process-validating="validateProcessing"
    />
    <collection-cancel-modal v-model="modalCancel" />
    <collection-modal-send-rrhh
      v-model="modalSendRRHH"
      :dataSend="dataCollection"
      :dataInfo="dataFetchInfo"
    />
    <collection-group-approval-modal
      v-model="modalCollectionGroupApproval"
      :dataSend="dataCollection"
      :dataInfo="dataFetchInfo"
      :collection-form-id="form_id"
    />
    <collection-group-payment-modal
      v-model="modalInvoicesPayment"
      :collection-form-id="form_id"
      @paymentCompleted="handlePaymentCompleted"
    />
  </div>
</template>

<script>
import { onMounted, reactive, ref, watchEffect, computed, toRaw } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import PayrollProcesing from '@/components/collection-and-billing/payroll/payroll-procesing.vue';
import DetailCollectionBilling from '@/components/collection-and-billing/detail/detail-collection-and-billing.vue';
import parseDate from '@/utils/dateFormatter';
import notification from '@/utils/notifications';
import EmitBus from '@/utils/events';
import {
  FETCH_COLLECTION_FORM_BY_ID,
  FETCH_COLLECTION_GROUP_COMMENTS,
  FETCH_USER_BY_ID,
  FETCH_COLLECTION_DATA_SEND_RRHH,
  FETCH_COLLECTION_GROUP_COLLECTIONS,
  FETCH_COLLECTION_GROUP_INVOICES,
  GET_COLLECTION_FORM,
  GET_COLLECTION_GROUP_COLLECTIONS,
  GET_COLLECTION_GROUP_INVOICES,
  GET_COLLECTION_DATA_RRHH,
  GET_LOGGED_USER
} from '@/store/types';
import getMonthNameByValue from '@/utils/monthByNumber';
import PageHeader from '@/components/page-header.vue';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import CommentsTest from '@/components/comments-test.vue';
import CollectionCancelModal from '@/components/collection-and-billing/collection-form/collection-cancel-modal.vue';
import CollectionListTable from '@/components/collection-and-billing/collection-form/collection-list-table.vue';
import CollectionModalSendRRHH from '@/components/collection-and-billing/collection-form/collection-modal-send-rrhh.vue';
import CollectionGroupApprovalModal from '@/components/collection-and-billing/collection-form/collection-group-approval-modal.vue';
import CollectionGroupPaymentModal from '@/components/collection-and-billing/collection-form/collection-group-payment-modal.vue';
import stepperCobranza from '@/components/collection-billing-stepper.vue';

// import CollectionChargeSummary from '@/components/collection-and-billing/collection-form/collection-charge-summary.vue';
import CollectionValidModal from '@/components/collection-and-billing/collection-form/collection-valid-modal.vue';
// import CollectionModalRRHH from '@/components/collection-and-billing/collection-form/collection-modal-send-rrhh.vue';

export default {
  name: 'BillingDetails',
  components: {
    'data-info': DatosTicket,
    'page-header': PageHeader,
    comments: CommentsTest,
    'payroll-procesing': PayrollProcesing,
    'detail-collection-billing': DetailCollectionBilling,
    'collection-cancel-modal': CollectionCancelModal,
    'collection-list': CollectionListTable,
    'collection-modal-send-rrhh': CollectionModalSendRRHH,
    // 'collection-charge-summary':CollectionChargeSummary,
    'collection-valid-modal': CollectionValidModal,
    'collection-group-approval-modal': CollectionGroupApprovalModal,
    'collection-group-payment-modal': CollectionGroupPaymentModal,
    'stepper-cobranza': stepperCobranza
    // 'collection-modal-send-rrhh':CollectionModalRRHH
  },
  setup() {
    // * Iniciación de variables
    const store = useStore();
    const loadSendToRRHH = ref(false);
    const route = useRoute();
    const router = useRouter();
    const form_id = parseInt(route.params.id);
    const loadingHumanSend = ref(false);
    const loadingApprovalCollectionGroup = ref(false);
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    // const brokerId=computed(()=>store.getters[GET_LOGGED_USER].id);
    // * Traer la data del formulario de cobranza desde vuex
    const dataFetchInfo = ref([]);
    const loadingValidate = ref(false);

    // * Estados del ticket
    const form_current_state = ref('');
    const stepper_props = reactive({
      steps: [],
      state: 'process',
      current: 0
    });

    // * Modal de validación
    const keyModal = ref(1);
    const modalType = ref({ id: 1, name: 'Validar' });
    const buttonModalType = reactive([
      {
        id: 1,
        name: 'Validar'
      },
      {
        id: 2,
        name: 'Enviar a RRHH'
      },
      {
        id: 3,
        name: 'Aprobar Cobranzas'
      },
      {
        id: 4,
        name: 'Pagar facturas'
      }
    ]);
    const changeKeyModal = (val) => {
      modalType.value = buttonModalType
        .filter((f) => f.id == val.keyModal)
        .reduce((acc, item) => {
          return [...acc, item];
        });
    };

    // abrir modales 1 = a validar  2 = a enviar rrhh  3 = aprobar cobranzas  4 = pagar facturas

    // * Modal de cancelación
    const modalCancel = ref(false);
    const openModalCancel = () => {
      modalCancel.value = true;
    };

    const modalValid = ref(false);
    const openModalValid = () => {
      modalValid.value = true;
    };

    // * Modal de cobranza
    const OpenModalSummary = ref(false);
    const openSummary = () => {
      OpenModalSummary.value = true;
    };

    // * Modal de aprobación de cobranzas
    const modalCollectionGroupApproval = ref(false);
    const openModalCollectionGroupApproval = () => {
      modalCollectionGroupApproval.value = true;
    };

    const modalInvoicesPayment = ref(false);
    const openModalPayment = () => {
      modalInvoicesPayment.value = true;
    };

    // * Modal general
    const loadingCollections = ref(false);
    const loadingInvoices = ref(false);

    // * Datos ticket
    const ticket_data = ref([]);

    // * Facturas disponibles para pago
    const approvedAndAvailableToPay = ref(false);

    // Agregar ceros antes del número
    const addLeadingZeros = (num, totalLength) => {
      return String(num).padStart(totalLength, '0');
    };

    // * Comentarios
    const comments = ref([]);
    const getBroker = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };
    const getNewCommment = async (value) => {
      const { date } = value;
      const { brokerId } = value;
      const brokerName = await getBroker(brokerId);

      comments.value.push({
        message: value.message,
        date: parseDate(date),
        author: brokerName
      });
    };
    const getCommentsById = async () => {
      const response_comments = await store
        .dispatch(FETCH_COLLECTION_GROUP_COMMENTS, route.params.id)
        .catch((e) => e.response);

      for (let i = 0; i < response_comments.data?.length; i++) {
        const element = response_comments.data[i];
        const brokerName = await getBroker(response_comments.data[i].brokerId);

        comments.value.push({
          date: parseDate(element.createdAt),
          message: element.message,
          author: brokerName
        });
      }
    };
    const states_list = computed(() => store.getters[GET_COLLECTION_FORM]);
    const errorHumandSend = ref('');

    const getCollectionDataSend = async () => {
      try {
        const dataFetchCollection = await store.dispatch(
          FETCH_COLLECTION_DATA_SEND_RRHH,
          form_id
        );
        if (dataFetchCollection.status == 200) {
          loadSendToRRHH.value = true;
        } else {
          loadSendToRRHH.value = false;
        }
      } catch (error) {
        errorHumandSend.value = error.response.data.message;
      }
    };

    const status = computed(() => store.getters[GET_COLLECTION_DATA_RRHH]);
    // * Modal RRHH
    const modalSendRRHH = ref(false);

    const dataCollection = computed(
      () => store.getters[GET_COLLECTION_DATA_RRHH]
    );

    const OpenModalRRHH = () => {
      if (errorHumandSend.value !== '' && !dataCollection.value.groups) {
        notification('error', 'Error', errorHumandSend.value);
      } else {
        modalSendRRHH.value = true;
      }
    };

    const validateProcessing = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.some(
        (obj) => obj.squaringStatus == 'PROCESSING'
      )
    );
    const showValidateButton = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.some(
        (s) =>
          s.squaringStatus == 'NO_PROCESSED' || s.squaringStatus == 'PROCESSING'
      )
    );
    const showSendHR = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.every(
        (e) =>
          e.squaringStatus == 'MATCH' ||
          e.squaringStatus == 'NO_MATCH' ||
          e.squaringStatus == 'ERROR'
      )
    );
    const validateStateCollectionHumanSend = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.some(
        (s) => s.status == 'BEWELL_VALIDATION'
      )
    );
    const showApproveCollectionGroup = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.some(
        (s) => s.status == 'HR_VALIDATION' // || e.squaringStatus == 'NO_MATCH'
      )
    );
    const validateApproved = computed(() =>
      store.getters[GET_COLLECTION_GROUP_COLLECTIONS].data.some(
        (s) => s.status == 'APPROVED'
      )
    );

    const invoicesToApprove = ref([]);

    watchEffect(() => {
      const allCollectionsApproved = store.getters[
        GET_COLLECTION_GROUP_COLLECTIONS
      ].data.every((s) => s.status === 'APPROVED');
      const someInvoiceUnpaid = invoicesToApprove.value.some(
        (i) => i.paidAt === null
      );
      approvedAndAvailableToPay.value =
        allCollectionsApproved && someInvoiceUnpaid;
    });

    const fetchInvoices = async () => {
      try {
        const resp = await store.getters[GET_COLLECTION_GROUP_INVOICES];
        const rawData = toRaw(resp);
        const invoices = rawData?.data ?? [];
        invoicesToApprove.value = invoices;
      } catch (error) {
        console.error('Error al obtener las facturas: ', error);
      }
    };

    const handlePaymentCompleted = async () => {
      await fetchCollectionGroupCollections();
      await fetchCollectionGroupInvoices();
    };

    watchEffect(async () => {
      EmitBus.on('loadingSendCollections', (val) => {
        loadingHumanSend.value = val;
      });
      // obtengo todos los estados del ticket
      const states = states_list.value.state;
      // ultimo estado del ticket
      form_current_state.value = states[states?.length - 1];

      // separo los estados por sus nombres para validar que existan y asi sacar su fecha a mostrar
      const created = states.find((obj) => obj.state === 'CREATED');
      const processing = states.find((obj) => obj.state === 'PROCCESING');
      const loaded = states.find((obj) => obj.state === 'LOADED');
      stepper_props.steps = [
        {
          title: 'Creado',
          date:
            created != undefined
              ? created.createdAt.replace('T', ' ').split('.')[0]
              : ''
        },
        {
          title: 'Procesando',
          date:
            processing != undefined
              ? processing.createdAt.replace('T', ' ').split('.')[0]
              : ''
        },
        {
          title: 'Cargado',
          date:
            loaded != undefined
              ? loaded.createdAt.replace('T', ' ').split('.')[0]
              : ''
        }
      ];
      // Selecciono el último estado que se encuentra el ticket
      stepper_props.current = states.length - 1;
      const canceled = states.find((obj) => obj.state === 'CANCELLED');
      const approved = states.find((obj) => obj.state == 'LOADED');

      if (canceled != undefined) {
        stepper_props.current = states.length - 2;
        stepper_props.state = 'error';
      } else {
        stepper_props.state = 'process';
      }

      if (approved) {
        stepper_props.state = 'finish';
      }
      // Datos del ticket
      const date = dataFetchInfo?.value.period?.split('-');
      let period = '';
      if (date != undefined) {
        period = `${date[0]}-${addLeadingZeros(date[1], 2)}`;
      }

      // veo que tipo de formulario se creo, si es holding, subholding y company
      let billing_type = '';
      let billing_type_name = '';

      if (dataFetchInfo.value.type == 'HOLDING') {
        billing_type = 'Holding';
        billing_type_name = dataFetchInfo?.value.holding.businessName;
      } else if (dataFetchInfo.value.type == 'SUBHOLDING') {
        billing_type = 'SubHolding';
        billing_type_name = dataFetchInfo?.value.subHolding.name;
      } else {
        billing_type = 'Empresa';
        billing_type_name = dataFetchInfo?.value.company.businessName;
      }

      // Correos
      const insurance_emails = [];
      const insurance_companies_names = [];
      dataFetchInfo?.value.insuranceCompanies.forEach((ins) => {
        const emails = ins.collectionEmails;
        insurance_emails.push(...emails);

        // Nombres de compañias aseguradoras
        insurance_companies_names.push(ins.businessName);
      });

      const clients_emails = [];
      dataFetchInfo?.value.payrollCompanies.forEach((comp) => {
        const emails = comp.collectionEmails;
        clients_emails.push(...emails);
      });

      ticket_data.value = [
        {
          key: 'Periodo cobranza',
          value: period
        },
        {
          key: billing_type,
          value: billing_type_name
        },
        {
          key: 'Aseguradoras',
          value: insurance_companies_names?.join(' - ')
        },
        {
          key: 'Correo aseguradoras',
          value:
            insurance_emails?.length != 0 ? insurance_emails.join(', ') : '-'
        },
        {
          key: 'Correo clientes',
          value: clients_emails?.length != 0 ? clients_emails.join(', ') : '-'
        }
      ];
    });

    // * Cancelation modal
    const cancelation_modal_visible = ref(false);

    // * Obtener formulario de cobranza en id al momento de cargar el componente
    const getTicketGroup = async () => {
      try {
        const { data } = await store.dispatch(
          FETCH_COLLECTION_FORM_BY_ID,
          form_id
        );
        dataFetchInfo.value = data;
      } catch {
        router.push({ name: 'Missing' });
      }
    };

    const fetchCollectionGroupCollections = async () => {
      loadingCollections.value = true;
      try {
        await store.dispatch(FETCH_COLLECTION_GROUP_COLLECTIONS, form_id);
      } catch (error) {
        loadingCollections.value = false;
        console.error(
          'Error fetching fetch collection group collections',
          error
        );
        throw error;
      }
      loadingCollections.value = false;
    };

    const fetchCollectionGroupInvoices = async () => {
      loadingInvoices.value = true;
      try {
        await store.dispatch(FETCH_COLLECTION_GROUP_INVOICES, form_id);
      } catch (error) {
        loadingInvoices.value = false;
        console.error('Error fetching fetch collection group invoices', error);
        throw error;
      }
      loadingInvoices.value = false;
    };

    onMounted(async () => {
      await fetchCollectionGroupCollections();
      await fetchCollectionGroupInvoices();
      await fetchInvoices();
      await getTicketGroup();
      await getCollectionDataSend();
      await getCommentsById();
    });

    return {
      getMonthNameByValue,
      dataFetchInfo,
      form_id,
      keyModal,
      modalValid,
      modalCollectionGroupApproval,
      modalCancel,
      modalSendRRHH,
      form_current_state,
      stepper_props,
      ticket_data,
      comments,
      openSummary,
      OpenModalSummary,
      OpenModalRRHH,
      changeKeyModal,
      openModalCancel,
      getBroker,
      getNewCommment,
      cancelation_modal_visible,
      loadSendToRRHH,
      states_list,
      openModalValid,
      openModalCollectionGroupApproval,
      showValidateButton,
      showSendHR,
      showApproveCollectionGroup,
      loadingValidate,
      validateProcessing,
      status,
      validateStateCollectionHumanSend,
      dataCollection,
      loadingHumanSend,
      loadingApprovalCollectionGroup,
      validateApproved,
      approvedAndAvailableToPay,
      modalInvoicesPayment,
      openModalPayment,
      handlePaymentCompleted,
      userRole
    };
  }
};
</script>
